import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { fieldHelperStyles } from './FieldHelper.styles';

const FieldHelper = ({ text, length, maxLength, error = '' }) => (
  <Box sx={fieldHelperStyles}>
    <Typography color={error ? 'error.main' : 'text.secondary'} variant="regular12">
      {error || text}
    </Typography>
    <Typography color="text.secondary" variant="regular12">
      {`${length} / ${maxLength}`}
    </Typography>
  </Box>
);

FieldHelper.propTypes = {
  text: PropTypes.string.isRequired,
  length: PropTypes.number.isRequired,
  maxLength: PropTypes.number.isRequired,
  error: PropTypes.string,
};

export default memo(FieldHelper);
